import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas.sort((a, b) => a.nameFr.localeCompare(b.nameFr)) },
    filtered: (state, datas) => { state.filtered = datas.map(item => item.id) }
  },
  actions: {
    init (state) { socket.get('SportSportDiscipline', 'Sport/Discipline/init') },
    set (state, data) {
      state.state.filtered = []
      if (data.sportId) {
        const parameters = { sportId: data.sportId }

        if (data.seasonId > 0 || data.competitionsId.length > 0) {
          parameters.joinr = [
            'SportSportEvent.disciplineId',
            'SportSportEventunit.eventId',
            'SportSportRound.eventUnitId'
          ]
          parameters.join = ['SportSportRound.competitionSeasonId']

          if (data.seasonId > 0) {
            parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
          }

          if (data.competitionsId.length === 1) {
            parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
          } else if (data.competitionsId.length > 1) {
            parameters['SportSportCompetitionseason.competitionId'] = {
              column: 'SportSportCompetitionseason.competitionId',
              operator: 'in',
              value: data.competitionsId
            }
          }
        }

        socket.get('SportSportDiscipline', 'Sport/Discipline/filtered', parameters)
      }
    }
  },
  getters: {
    list: (state) => state.list,
    filtered: (state) => state.filtered,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
